import { render, staticRenderFns } from "./SwitchTipDialog.vue?vue&type=template&id=f6ff2af8"
import script from "./SwitchTipDialog.vue?vue&type=script&lang=js"
export * from "./SwitchTipDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports